// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"413":"monitor","535":"login","795":"goods","809":"account","826":"index"}[chunkId] + "." + {"413":"a7c86b94","535":"5d2b5e81","795":"dce5b55b","809":"08aa971e","826":"a25d3370"}[chunkId] + ".css";
};